import React from 'react';
import { Redirect, Route as ReactRoute, Switch } from '@okapi/router-react';
import { memo } from 'common/hocs';

import { routes, Route } from './routes';

const Router = memo(() => <NestedRoutes routesTree={routes} />);

const NestedRoutes: React.FC<{ routesTree: Route[] | undefined }> = ({ routesTree }) => (
  <Switch>
    {routesTree?.map(({ routes: nestedRoutes, component: Component, path, key, strict, exact }) => (
      <ReactRoute path={path} key={key} strict={strict} exact={exact}>
        {Component ? (
          /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
          /* @ts-ignore */
          <Component>
            <NestedRoutes routesTree={nestedRoutes} />
          </Component>
        ) : (
          <NestedRoutes routesTree={nestedRoutes} />
        )}
      </ReactRoute>
    ))}
    <ReactRoute path="*">
      <Redirect to="/404" />
    </ReactRoute>
  </Switch>
);

export { Router, routes };
